/**
 * 📦 V2 Sales API client
 * Rotas /api/v2/sales
 */

import v2Api from './index';

export const salesV2API = {
  /**
   * Cria venda + sale_items + sale_commissions (atômico).
   * Body: { plan_id, customer_name, customer_email, total_amount_cents,
   *         payment_method, customer_document?, customer_phone?, shipping_address?,
   *         coupon_code?, affiliate_user_id?, manager_user_id?, coproducer_user_id?,
   *         parent_sale_id? (upsell), payment_status?, payment_transaction_id? }
   */
  create: (data) => v2Api.post('/sales', data),

  /** Lista por produto (admin/produtor). Query: limit, offset */
  listByProduct: (productId, params = {}) =>
    v2Api.get(`/sales/by-product/${productId}`, { params }),

  /**
   * Vendas do owner autenticado (agregadas em todos seus produtos).
   * Query opcional: { limit (max 200), offset, status }
   */
  listMine: (params = {}) => v2Api.get('/sales/me', { params }),

  /** Lista por email do cliente. */
  listByCustomerEmail: (email) => v2Api.get(`/sales/by-customer-email/${encodeURIComponent(email)}`),

  findById: (id) => v2Api.get(`/sales/${id}`),
  findByUuid: (uuid) => v2Api.get(`/sales/uuid/${uuid}`),

  /** Lista upsells (filhas) de uma venda principal (R11.4). */
  listUpsells: (id) => v2Api.get(`/sales/${id}/upsells`),

  // ===== Webhooks internos =====
  confirmPayment: (id, body = {}) => v2Api.post(`/sales/${id}/confirm-payment`, body),
  refund: (id, body = {}) => v2Api.post(`/sales/${id}/refund`, body),
  cancelItem: (saleItemId, body) => v2Api.post(`/sales/items/${saleItemId}/cancel`, body),

  // ===== KAN-12 / Pacote 5 — Reportar pedido =====
  /** Marca metadata.frustration_type do sale_item e move pra coluna escolhida da aba Frustrações. */
  report: (saleItemId, body) => v2Api.post(`/sales/items/${saleItemId}/report`, body),
  /** Lista tipos de frustração disponíveis pro select do drawer. */
  getFrustrationTypes: () => v2Api.get('/sales/items/frustration-types'),
};

export default salesV2API;
